define("shared/components/shared/color-picker/swatches", ["exports", "@ember/component", "@ember/service", "@ember/utils", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _utils, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="cLB--colorPicker" data-test-id="swatch-items">
    {{#if this.shouldShowEmptySpace}}
      <div class="u--p__b__lg" data-test-id="swatch-items-empty"></div>
    {{/if}}
    {{#each @colors as |color|}}
      <Shared::Ui::Button
        @isDisabled={{@isDisabled}}
        @onClick={{fn @onClick color}}
        @variant="unstyled"
        class="u--p__0"
        data-test-id="color-item-button"
      >
        <div
          class="cLB--colorPicker__swatch
            {{if (eq @selectedColor color) 'is--active'}}
            {{if (eq color this.lightColor) 'is--white'}}"
          data-test-id={{concat "color-item-" color}}
          {{style color=color}}
        ></div>
      </Shared::Ui::Button>
    {{/each}}
  </div>
  */
  {
    "id": "OZfvCmk/",
    "block": "[[[10,0],[14,0,\"cLB--colorPicker\"],[14,\"data-test-id\",\"swatch-items\"],[12],[1,\"\\n\"],[41,[30,0,[\"shouldShowEmptySpace\"]],[[[1,\"    \"],[10,0],[14,0,\"u--p__b__lg\"],[14,\"data-test-id\",\"swatch-items-empty\"],[12],[13],[1,\"\\n\"]],[]],null],[42,[28,[37,2],[[28,[37,2],[[30,1]],null]],null],null,[[[1,\"    \"],[8,[39,3],[[24,0,\"u--p__0\"],[24,\"data-test-id\",\"color-item-button\"]],[[\"@isDisabled\",\"@onClick\",\"@variant\"],[[30,3],[28,[37,4],[[30,4],[30,2]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[11,0],[16,0,[29,[\"cLB--colorPicker__swatch\\n          \",[52,[28,[37,5],[[30,5],[30,2]],null],\"is--active\"],\"\\n          \",[52,[28,[37,5],[[30,2],[30,0,[\"lightColor\"]]],null],\"is--white\"]]]],[16,\"data-test-id\",[28,[37,6],[\"color-item-\",[30,2]],null]],[4,[38,7],null,[[\"color\"],[[30,2]]]],[12],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[2]],null],[13]],[\"@colors\",\"color\",\"@isDisabled\",\"@onClick\",\"@selectedColor\"],false,[\"if\",\"each\",\"-track-array\",\"shared/ui/button\",\"fn\",\"eq\",\"concat\",\"style\"]]",
    "moduleName": "shared/components/shared/color-picker/swatches.hbs",
    "isStrictMode": false
  });
  let SwatchesComponent = _exports.default = (_class = class SwatchesComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "cache", _descriptor2, this);
      _defineProperty(this, "lightColor", '#FFFFFF');
    }
    get cacheKey() {
      return `${this.args.id}_${this.auth.currentAccount.id}`;
    }

    // prevents the jarring movement of the menu component
    get shouldShowEmptySpace() {
      const recentColors = this.cache.retrieve(this.cacheKey);
      return (0, _utils.isEmpty)(recentColors);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SwatchesComponent);
});